export const ROUTERS_MAP = {
    CHANNEL: '/dashboard/videos/department',
    KNOWLEDGE_DATA: '/dashboard/videos/review',
    MANAGE_DATA: '/manage-data',
    ARTIFACTS: '/manage-data/artifacts',
    CHANNELS: '/manage-data/department',
    PROFILE: '/dashboard/profile',
    NOTES: '/profile/notes',
    VIDEO: '/dashboard/videos/video',
    INTEGRATIONS: '/integrations',
    LOGIN:'/auth',
    AI_AGENTS: '/ai-teams/ai-agents',
    COPILOT: '/ai-teams/copilot',
    USERS_LIST: '/users/persons',
    USERS_NEW_LIST: '/users/new',
    ROLES: '/dashboard/roles',
    CONNECT_CALENDAR: '/connect-calendar',
    AUTH: '/auth'
}